import type { UnionTypeLibelle } from '@/features/domaine/types/techniques'

export const ConditionRealisation = ['VeilleContrat', 'DispositionApprenti'] as const

export type ConditionRealisation = (typeof ConditionRealisation)[number]

export const ConditionRealisationLibelle: UnionTypeLibelle<ConditionRealisation> = {
  VeilleContrat: 'Veille du contrat',
  DispositionApprenti: "Disposition de l'apprenti",
} as const
